import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <button
      // href="https://github.com/RishiSingh/RishiSingh.github.io"
      className="link footer__link"
      style={{cursor: 'default'}}
    >
      Created By Rishi Singh
    </button>
  </footer>
);

export default Footer;
